import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  makeStyles,
  CircularProgress,
} from '@material-ui/core';
import { ConversationHistory } from './ConversationHistory';
import { QueryInput } from './QueryInput';
import { ErrorDisplay } from './ErrorDisplay';
import { useSessionStorage } from './hooks/useSessionStorage';
import { useMcpApi } from './hooks/useMcpApi';
import { createUserMessage, createAssistantMessage } from './utils/messageFactory';

const useStyles = makeStyles(theme => ({
  dialogContent: {
    minWidth: 800,
    minHeight: 600,
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  loadingText: {
    marginLeft: theme.spacing(1),
  },
}));

type AiDataMaintenanceModalProps = {
  open: boolean;
  onClose: () => void;
};

export const AiDataMaintenanceModal = ({ open, onClose }: AiDataMaintenanceModalProps) => {
  const classes = useStyles();
  const { userId, conversation, setConversation, clearConversation } = useSessionStorage();
  const { isLoading, error, setError, sendQuery } = useMcpApi(userId);

  const handleSubmit = async (queryText: string) => {

    const userMessage = createUserMessage(queryText);
    setConversation(prev => [...prev, userMessage]);

    const result = await sendQuery(queryText);

    if (result) {
      const assistantMessage = createAssistantMessage(result);
      setConversation(prev => [...prev, assistantMessage]);
    }
  };

  const handleClearConversation = () => {
    clearConversation();
    setError(null);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="ai-data-maintenance-dialog-title"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="ai-data-maintenance-dialog-title">AI Agent</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <ConversationHistory
          messages={conversation}
        />

        {isLoading && (
          <div className={classes.loadingContainer}>
            <CircularProgress size={24} />
            <span className={classes.loadingText}>Processing request...</span>
          </div>
        )}

        <QueryInput
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />

        <ErrorDisplay
          error={error}
        />
      </DialogContent>
      <DialogActions>
        {conversation.length > 0 && (
          <Button
            onClick={handleClearConversation}
            color="secondary"
            disabled={isLoading}
          >
            Clear Conversation
          </Button>
        )}
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
